module.exports = __webpack_public_path__ + "img/icon-energy-dishwasher.6f60b8bf.svg";